import { filledFieldBaseStyles } from './FilledFieldBase.styles';
import { outlinedFieldBaseStyles } from './OutlinedFieldBase.styles';
export const fieldBaseVariantStyles = {
    filled: filledFieldBaseStyles,
    outlined: outlinedFieldBaseStyles,
};
